import { ActionButton, Text, Divider, AvatarV2, Avatar } from "../custom-components";
import { IcSearch } from "../custom-components/Icon";
import "../styles/header.css";
import "../styles/hamburger.css";
import { useLocation, useNavigate } from "react-router-dom";
import SignUp from "./SignUp";
import SandboxIndicator from "./SandboxIndicator";
import GlobalSearch from "./GlobalSearch";
import AssistantBot from "./AssistantBot";
import SideNav from "./SideNav";
import TopNav from "./TopNav";
import BusinessGroupSelector from "./BusinessGroupSelector";
import { useState, useEffect, useRef } from "react";
import { getUserProfile, fetchBusinessApplication } from "../store/actions/CommonAction";
import { useSelector, useDispatch } from "react-redux";
import { CLEAR_SESSION } from "../store/constants/Constants";
import { disableSandboxMode } from "../utils/sandboxMode";
import config from "../utils/config";
import { makeAPICall } from "../utils/ApiCall";

// UUID generator function (same as in CommonAction.js)
const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const Header = ({ isSidebarOpen, toggleSidebar, hideSideNav, hideSideAndFooter, hideAll }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const privuLogo = new URL("../assets/privu-logo.png", import.meta.url).href;

  const handleClick = () => {
    navigate("/signup");
  };

  const handleLogIn = () => {
    navigate("/adminLogin");
  };

  const tenantId = useSelector((state) => state.common.tenant_id);
  const token = useSelector((state) => state.common.session_token);
  const businessId = useSelector((state) => state.common.business_id);
  const userId = useSelector((state) => state.common.user_id);
  const companyName = useSelector((state) => state.common.companyName);
  const pan = useSelector((state) => state.common.pan);

  const handleConfigureSystem = () => {
    navigate("/consent");
  };
  const [showLogout, setShowLogout] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showAssistant, setShowAssistant] = useState(false);
  const avatarRef = useRef(null);

  const handleAvatarClick = (e) => {
    e.stopPropagation();
    setShowLogout(!showLogout);
  };
  
  const handleLogOut = async () => {
    setShowLogout(false);
    
    // Call audit API before logout
    try {
      await logAuditEvent(tenantId, businessId, userId, token, companyName, pan);
    } catch (error) {
      console.error('Failed to log audit event:', error);
      // Continue with logout even if audit fails
    }
    
    // Clear sandbox mode data
    disableSandboxMode();
    console.log('🔓 Logging out - Sandbox mode cleared');
    
    // Clear any stored session data if needed
    dispatch({ type: CLEAR_SESSION });
    
    // Replace history to prevent back navigation after logout
    navigate("/adminLogin", { replace: true });
    
    // Clear all navigation history
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', function(event) {
      window.history.pushState(null, '', window.location.href);
    });
  };

  // Function to log audit event on logout
  const logAuditEvent = async (tenantId, businessId, userId, sessionToken, companyName, pan) => {
    if (!tenantId || !businessId) {
      console.warn('Missing tenantId or businessId for audit log');
      return;
    }

    try {
      const txnId = uuidv4();
      const transactionId = uuidv4();
      
      // Get client IP address (using placeholder as per user's request to keep values static)
      const ipAddress = "192.168.1.1";

      const headers = {
        txn: txnId,
        "X-Tenant-ID": tenantId,
        "X-Business-ID": businessId,
        "X-Transaction-ID": transactionId,
        "Content-Type": "application/json",
      };

      // Add session token if available
      // if (sessionToken) {
      //   headers["x-session-token"] = sessionToken;
      // }

      // Build initiator string with PAN
      const initiator = "Data Fiduciary";

      const body = {
        actor: {
          id: "PAN No./Client ID", // Use userId if available, otherwise default
          role: "Legal-Admin",
          type: "USER"
        },
        businessId: businessId,
        group: "Consent",
        component: "Privu Consent Management System",
        actionType: "LOGOUT",
        resource: {
          type: "userId",
          id: userId || txnId // Use userId if available, otherwise default
        },
        initiator: initiator,
        context: {
          txnId: transactionId,
          ipAddress: ipAddress
        },
        extra: {
          legalEntityName: companyName || "XYZ Pvt Ltd",
          pan: pan || ""
        }
      };

      const response = await makeAPICall(
        config.get_audit_reports,
        "POST",
        body,
        headers
      );

      console.log('✅ Audit log created successfully:', response);
      return response;
    } catch (error) {
      console.error('❌ Error creating audit log:', error);
      throw error;
    }
  };

  const handleProfile = () => {
    setShowLogout(false);
    navigate("/profile");
  };

  // Close logout menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (avatarRef.current && !avatarRef.current.contains(event.target)) {
        setShowLogout(false);
      }
    };

    if (showLogout) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showLogout]);

  const firstChar = useSelector((state) => state.common.firstChar);
  const companyLogo = useSelector((state) => state.common.companyLogo);
  console.log("Company Name from Redux:", companyName);
  console.log("First Character from Redux:", firstChar);
  console.log("Company Logo from Redux:", companyLogo);

  // useEffect(() => {
  //   if (!tenantId) {
  //     console.warn(" Tenant ID is missing in Redux, cannot call API.");
  //     return;
  //   }

  //   console.log(" Tenant ID from Redux:", tenantId);

  
  //   const getBusinessDetails = async () => {
  //     const { companyName, firstChar } = await fetchBusinessApplication(tenantId, token);
  //     console.log("Business Name:", companyName);
  //     console.log("First Character:", firstChar);
  //   };

  //   getBusinessDetails();

  // }, [token, tenantId]);

  const location = useLocation();
  const path = location.pathname;
  if (
    path === "/adminLogin" ||
    path === "/signup"  //new
    // path === "/createConsent" //new
  ) {
    return null;
  }
  if (path === "/") {
    return (
      <div className="mainDiv">
        <div className="logoDiv" style={{ display: 'flex', alignItems: 'center' }}>
          <img src={privuLogo} alt="Privu Logo" className="logoImg" style={{ marginRight: '12px' }} />
          <Text appearance="heading-xxs">Consent Management Platform</Text>
        </div>
        <div className="header-buttons">
          <ActionButton
            appearance="default"
            kind="tertiary"
            size="medium"
            label="Sign Up"
            onClick={handleClick}
          ></ActionButton>
          <ActionButton
            appearance="default"
            kind="primary"
            size="medium"
            label="Log In"
            onClick={handleLogIn}
          ></ActionButton>
        </div>
      </div>
    );
  } else {
    return (
      <div className="mainDiv">
        <div className="logoDiv">
          {/* Hamburger Menu - Only visible on mobile/tablet */}
          {toggleSidebar && (
            <button
              className={`hamburger-menu ${isSidebarOpen ? 'active' : ''}`}
              onClick={toggleSidebar}
              aria-label="Toggle navigation menu"
              aria-expanded={isSidebarOpen}
              style={{ marginRight: '12px' }}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          )}
          
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: '12px' }}>
            <img src={privuLogo} alt="Privu Logo" className="logoImg" style={{ height: '28px', marginRight: '12px' }} />
            <Text appearance="body-s" style={{ fontSize: '14px', color: '#4b5563', fontWeight: '600' }}>Consent Management Platform</Text>
          </div>
          
          {/* Sandbox Mode Indicator */}
          <SandboxIndicator />
        </div>
        
        <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          <BusinessGroupSelector />
        </div>
        <div className="header-icons" style={{ display: 'flex', alignItems: 'center' }}>
          <div 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              backgroundColor: '#f1f5f9', 
              borderRadius: '20px', 
              padding: '6px 14px', 
              marginRight: '16px',
              cursor: 'text',
              border: '1px solid #e2e8f0'
            }}
            onClick={() => setShowSearch(true)}
          >
            <IcSearch height={16} width={16} color="#64748b" />
            <input 
              type="text" 
              placeholder="Search..." 
              readOnly
              style={{ 
                border: 'none', 
                background: 'transparent', 
                outline: 'none', 
                marginLeft: '8px', 
                fontSize: '14px', 
                width: '180px',
                color: '#64748b',
                cursor: 'text'
              }}
            />
          </div>
          <button 
            className="assistant-bot-trigger"
            onClick={() => setShowAssistant(true)}
            title="AI Assistant"
          >
            <span className="bot-icon">🤖</span>
          </button>
          {/* Profile moved to SideNav */}
        </div>

        {/* Global Search Modal */}
        <GlobalSearch isOpen={showSearch} onClose={() => setShowSearch(false)} />
        
        {/* Assistant Bot */}
        <AssistantBot isOpen={showAssistant} onClose={() => setShowAssistant(false)} />
      </div>
    );
  }
};

export default Header;
